import React, { Component } from 'react';
import { connect } from "react-redux";
import Schedule from "../../../ducks/Schedule";
import Modal from 'react-bootstrap4-modal';
import { bindActionCreators } from "redux";
import './index.css';
import { Spinner, BlueSmallSpinner } from '../../common/Spinner/index';
import moment from 'moment';
import Select from 'react-select-nested-group';
import editIcon from "../../../assets/img/ic_edit.png";
import saveIcon from "../../../assets/img/ic_save.png";
import cancelIcon from "../../../assets/img/ic_cancel.png";
import trash_bin from "../../../assets/img/trash_bin.png";
import toastr from "toastr";
import * as _ from "lodash";

class AssignSchedule extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            schedule: {},
            selectedSchedule: {},
            driverName: "",
            driverId: "",
            vehicles: [],
            savingSingleRecord: [],
            selectedVehicle: "",
            errors: {}
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    loadData = async () => {

        this.setState({
            loading: true,
            driverName: "",
            driverId: "",
            selectedVehicle: "",
            vehicles: [],
            schedule: {},
        })
        await this.props.actions.getSchedules();
        if (this.props.schedules.length) {
            let data = this.props.schedules[0];
            this.handleScheduleChange({ value: data._id, label: data.name });
        }
        this.setState({
            ...this.state,
            loading: false,
            driverName: this.props.driverName,
            driverId: this.props.driverId,
            vehicles: this.props.vehicles
        })
    }

    async navigateToSchedule() {
        this.props.closePopup()
    }
    async editMode(obj) {

        const index = obj.index;
        let schedule = _.clone(this.state.schedule);
        let item = schedule.slots[index]
        item.editMode = obj.editMode;
        schedule.slots[index] = item;
        this.setState({ ...this.state, schedule })

    }
    handleVehicleChange(index, selectedOption) {
        this.setState({ ...this.state, selectedVehicle: selectedOption ? selectedOption.value : null });
    }

    async assignSchedule(value) {
        // let schedule = _.clone(this.state.schedule);
        try {

            let isEdit = false;
            // let schedule = _.clone(this.state.schedule);

            // _.forEach(schedule.slots[value.index].occupiedBy, (item, index) => {
            //     if (item.driver === this.state.driverId) {
            //         schedule.slots[value.index].occupiedBy[index].thing = this.state.selectedVehicle;
            //         isEdit = true;
            //     }
            // })

            // if (!isEdit) {
            //     schedule.slots[value.index].occupiedBy.push({ driver: this.state.driverId, thing: this.state.selectedVehicle })
            // }

            if(!this.state.selectedVehicle){
                return  toastr.error("Please select a vehicle");
            }
            let obj = {
                scheduleId: this.state.schedule._id,
                slotId: this.state.schedule.slots[value.index]._id,
                vehicleId: this.state.selectedVehicle,
                driverId: this.state.driverId,
                isEdit
            }

            await this.props.actions.assignSlot(obj);
            // schedule.slots[value.index].occupiedBy.push({ driver: this.state.driverId, thing: this.state.selectedVehicle })
            // this.editMode(value);
            setTimeout(() => {this.handleScheduleChange(this.state.selectedSchedule);
                this.setState({...this.state, selectedVehicle: ""});
            }, 600)

            toastr.success("Slots updated successfully!");


        } catch (e) {
            toastr.error(e.response ? e.response.data.message : e);
        }
    }
    async removeSchedule(obj) {

        let schedule = this.state.schedule;
        let slot = {
            scheduleId: this.state.schedule._id,
            slotId: obj.slotId,
            driverSlotId: obj.driverSlotId
        }
        await this.props.actions.removeSlot(slot);
        schedule.slots[obj.index].occupiedBy = _.filter(schedule.slots[obj.index].occupiedBy, o => {
            if (o._id.toString() !== obj.driverSlotId) {
                return o;
            }
        })
        this.setState({ ...this.state, schedule })
        toastr.success("Slots updated successfully!");

    }
    handleScheduleChange = async (selectedOption) => {
        if (selectedOption) {
            await this
                .props
                .actions
                .getSlots(selectedOption.value);
            this.setState({ ...this.state, schedule: this.props.schedule, selectedSchedule: selectedOption })
        }
    }


    render() {
        const loader = <Spinner key="1" />
        const smallLoader = <BlueSmallSpinner key="1" />;

        return (

            <Modal visible={this.props.scheduleVisible}  >
                <div className="popup-close-btn">
                    <button type="button" className="close close-x" aria-label="Close" onClick={this.navigateToSchedule.bind(this)}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                {this.state.loading ? [loader] :
                    <div>
                        <div className='col-lg-4 col-md-4 col-sm6 form-group'>
                            <h4>{this.state.driverName}</h4>
                            <Select
                                name="form-field-name"
                                isClearable={false}
                                isSearchable={true}
                                defaultValue={{ value: this.props.schedules[0]._id, label: this.props.schedules[0].name }}
                                placeholder="Select Schedule"
                                onChange={this.handleScheduleChange}
                                options={this.props.schedules && this
                                    .props
                                    .schedules
                                    .map(item => {
                                        return { value: item._id, label: item.name }
                                    })} />
                        </div>
                        <div>

                            <div className="modal-body model-hight">
                                {this.state.schedule && this.state.schedule.slots ?
                                    <div className="row">

                                        <table className="table-auxo">
                                            <thead>
                                                <tr>
                                                    <th>Start Day </th>
                                                    <th>End Day </th>
                                                    <th>Start Time </th>
                                                    <th>End Time </th>
                                                    <th>Vehicle</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.schedule && this
                                                    .state
                                                    .schedule.slots
                                                    .map((item, index) => {
                                                        let driverFound = { found: false, driverSlotId: null };

                                                        return (
                                                            <tr key={index} className="driver-listing">
                                                                <td className="edit-field">
                                                                    {moment().isoWeekday(item.startDay).format("dddd")}

                                                                </td>
                                                                <td className="edit-field">
                                                                    {moment().isoWeekday(item.endDay).format("dddd")}
                                                                </td>
                                                                <td className="edit-field">
                                                                    {moment(item.startTime, ["HH"]).format("hh A")}

                                                                </td>
                                                                <td className="edit-field">
                                                                    {moment(item.endTime, ["HH"]).format("hh A")}

                                                                </td>
                                                                <td className="edit-field">
                                                                    {item.editMode ?
                                                                        <Select
                                                                            name="form-field-name"
                                                                            isClearable={false}
                                                                            isSearchable={false}
                                                                            onChange={this.handleVehicleChange.bind(this, index)}
                                                                            options={this.state.vehicles && this
                                                                                .state
                                                                                .vehicles
                                                                                .map(item => {

                                                                                    return { value: item._id, label: item.plateNumber }
                                                                                })} /> : <span>  {item.occupiedBy.length
                                                                                    ? item.occupiedBy
                                                                                        .map((obj, keyIndex) => {

                                                                                            return <span key={keyIndex}>{
                                                                                                obj.driver.toString() === this.state.driverId ? <span>{this.state.vehicles && this
                                                                                                    .state
                                                                                                    .vehicles
                                                                                                    .map((item, index2) => {
                                                                                                        driverFound = { found: true, driverSlotId: obj._id }
                                                                                                        return <span key={index2}>{item._id.toString() === obj.thing.toString() ? item.plateNumber : ""} </span>
                                                                                                    })}</span>
                                                                                                    : ""
                                                                                            }</span>
                                                                                        }) : ""}
                                                                            {driverFound.found ? "" : "N/A"}
                                                                        </span>}

                                                                </td>
                                                                <td className="last-column-width">
                                                                    {this.state.savingSingleRecord[index] && this.state.savingSingleRecord[index] === true ? [smallLoader] : <div>
                                                                        {item.editMode ? <div>
                                                                            <a onClick={this.assignSchedule.bind(this, { index, editMode: false })}><img className="save-records" src={saveIcon} alt="" /></a>
                                                                            <a onClick={this.editMode.bind(this, { index, editMode: false })} ><img src={cancelIcon} alt="" /></a></div>
                                                                            : <div>


                                                                                {driverFound.found ? <a onClick={this.removeSchedule.bind(this, { index, slotId: item._id, driverSlotId: driverFound.driverSlotId })}><img src={trash_bin} className="width16" alt="" /></a> : <a onClick={this.editMode.bind(this, { index, editMode: true })}><img src={editIcon} alt="" /></a>}

                                                                            </div>}
                                                                    </div>}
                                                                </td>


                                                            </tr>
                                                        )
                                                    })}


                                            </tbody>
                                        </table>


                                    </div> : ""}



                            </div>
                            <div className="modal-footer model-btn width100">
                                <button
                                    className="btn close-btn"
                                    onClick={this.navigateToSchedule.bind(this)}>
                                    Close
                    </button>

                            </div>
                        </div>

                    </div>}

            </Modal>

        );
    }
}

AssignSchedule.propTypes = {};
AssignSchedule.defaultProps = {};
const mapStateToProps = state => ({ schedule: state.schedule.schedule, schedules: state.schedule.schedules });

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Schedule.creators, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(AssignSchedule);
